import { FilterSection } from './FilterSection';
import { Filters } from '../../types/filters';

interface IndustriesFilterProps {
    filters: Filters;
    onFiltersChange: (filters: Filters) => void;
    allIndustries: string[];
}

export function IndustriesFilter({ filters, onFiltersChange, allIndustries }: IndustriesFilterProps) {
    function handleCheckboxChange(value: string) {
        const currentValues = filters.industries;
        const newValues = currentValues.includes(value)
            ? currentValues.filter(v => v !== value)
            : [...currentValues, value];

        onFiltersChange({ ...filters, industries: newValues });
    }

    return (
        <FilterSection title="Industries" defaultOpen={true}>
            <div className="space-y-1.5">
                {[...allIndustries].sort((a, b) => a.localeCompare(b)).map((industry) => (
                    <label key={industry} className="flex items-center group cursor-pointer">
                        <input
                            type="checkbox"
                            checked={filters.industries.includes(industry)}
                            onChange={() => handleCheckboxChange(industry)}
                            className="w-4 h-4 rounded border-gray-300 text-indigo-500 focus:ring-indigo-500"
                        />
                        <span className="ml-2 text-sm text-gray-600 group-hover:text-gray-900">{industry}</span>
                    </label>
                ))}
            </div>
        </FilterSection>
    );
} 